import React from "react";

import {
	DEFAULT_TIME,
	formatDateTimeValue,
	getDateStr,
	getTimeStr
} from "src/common/utils/dates";
import { usePatientDateOfBirth } from "src/features/patient";

export function useGetDefaultTimestamp(): (options: {
	showTimeInput: boolean;
	applyCurrentDate: boolean;
	applyDateOfBirth: boolean;
}) => string | undefined {
	const dob = usePatientDateOfBirth();
	return React.useCallback(
		({ showTimeInput, applyCurrentDate, applyDateOfBirth }) => {
			if (applyCurrentDate) {
				const now = new Date();
				if (showTimeInput) {
					return formatDateTimeValue(
						getDateStr(now),
						getTimeStr(now)
					);
				} else {
					return formatDateTimeValue(getDateStr(now), DEFAULT_TIME);
				}
			}
			if (applyDateOfBirth && dob !== undefined) {
				return formatDateTimeValue(dob, DEFAULT_TIME);
			}
		},
		[dob]
	);
}
